<template lang="html">
    <div class="review" :style="{
            opacity: approved?1:0.5
        }">
        <div class="review__head">
            <StarRating :rating="rating" class="review__rating" />
            <div class="review__prom">{{ratingText}}/5.00</div>
            <div class="review__date">
                {{momentDate}} | {{author}}
            </div>
        </div>
        <div class="review__body">
            <div class="review__description">
                {{text}}
            </div>
        </div>
    </div>
</template>

<script>
    import StarRating from '@/components/ui/StarRating';
    import * as moment from 'moment';

    export default {
        components: {
            StarRating
        },
        props: {
            rating: {
                type: Number,
                default: 0
            },
            date: {
                type: String,
                default: ''
            },
            author: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: ''
            },
            approved: {
                type: Number,
                default: 1
            }
        },
        computed: {
            ratingText() {
                if(this.rating % 1 == 0)
                    return `${this.rating}.00`;
                else
                    return `${this.rating}0`
            },
            momentDate() {
                let dateString = this.date.slice(0, 4)+this.date.slice(5, 7)+this.date.slice(8, 10);
                return moment(dateString).format('ll');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .review {
        margin-top: 20px;
        margin-bottom: 5px;

        &__head {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }

        &__rating {
            font-size: 8px;
        }

        &__prom {
            color: #898989;
            font-size: 11px;
            font-weight: 500;
            line-height: 13px;
            margin-left: 14px;
            margin-right: 41px;
            justify-content: center;
        }

        &__date {
            color: #373435;
            font-size: 11px;
            font-weight: 500;
            line-height: 13px;
            margin-top: 5px;
            width: 100%;

            @include media-breakpoint-up(sm) {
                margin-top: 0px;
                width: auto;
            }
        }

        &__description {
            margin-top: 10px;
            font-size: 14px;
            font-weight: 300;
            line-height: 16px;
        }

        &__readall {
            cursor: pointer;
            color: $color-primary;
            font-size: 14px;
            font-weight: 500;
            line-height: 21px;
            margin: 23.5px auto;
            text-align: center;

            &:hover {
                text-decoration: underline;
            }
        }
    }
</style>